<!-- Start Page Title Area -->
<div class="page-title-area">
    <div class="container">
        <div class="page-title-content">

            <h2>Privacy Policy</h2>

            <ul>
                <li>
                    <a routerLink="/">Home</a>
                </li>

                <li>Privacy Policy</li>
            </ul>

        </div>
    </div>
</div>
<!-- End Page Title Area -->


<!-- Start Privacy Policy Area -->
<section class="privacy-policy-area ptb-100">
    <div class="container">

        <div class="privacy-policy-content">

            <!-- Introduction -->
            <div class="privacy-policy-intro">
                <span>SolarCiti Privacy Policy</span>

                <h2>
                    Your Privacy Matters to Us
                </h2>

                <p>
                    This Privacy Policy explains how SolarCiti
                    ("SolarCiti", "we", "us", or "our") collects,
                    uses, stores, and protects information provided by
                    visitors and customers ("User", "you", or "your")
                    when you use our website and services.
                </p>

                <p>
                    By accessing or using the SolarCiti website, you
                    acknowledge that you have read and understood this
                    Privacy Policy and agree to the practices described
                    below.
                </p>
            </div>


            <!-- 01 -->
            <div class="privacy-policy-item">

                <h3>
                    <span>01</span>
                    Information We Collect
                </h3>

                <p>
                    SolarCiti may collect information that you voluntarily
                    provide when you interact with our website, request
                    information, calculate solar savings, submit an enquiry,
                    or request a consultation.
                </p>

                <p>
                    Depending on the services you use, this information may
                    include:
                </p>

                <ul>
                    <li>
                        <i class="bx bx-check"></i>
                        Name and contact details
                    </li>

                    <li>
                        <i class="bx bx-check"></i>
                        Mobile number and email address
                    </li>

                    <li>
                        <i class="bx bx-check"></i>
                        Property or installation location
                    </li>

                    <li>
                        <i class="bx bx-check"></i>
                        Electricity consumption and energy requirements
                    </li>

                    <li>
                        <i class="bx bx-check"></i>
                        Information submitted through enquiry and
                        consultation forms
                    </li>

                    <li>
                        <i class="bx bx-check"></i>
                        Information required to provide solar-related
                        services
                    </li>
                </ul>

            </div>


            <!-- 02 -->
            <div class="privacy-policy-item">

                <h3>
                    <span>02</span>
                    Information Collected Automatically
                </h3>

                <p>
                    When you visit the SolarCiti website, certain technical
                    and usage information may be collected automatically.
                    This information helps us understand how visitors use
                    our website and improve its performance.
                </p>

                <ul>
                    <li>
                        <i class="bx bx-check"></i>
                        IP address
                    </li>

                    <li>
                        <i class="bx bx-check"></i>
                        Browser type and version
                    </li>

                    <li>
                        <i class="bx bx-check"></i>
                        Device type and operating system
                    </li>

                    <li>
                        <i class="bx bx-check"></i>
                        Pages visited on our website
                    </li>

                    <li>
                        <i class="bx bx-check"></i>
                        Date and time of website visits
                    </li>

                    <li>
                        <i class="bx bx-check"></i>
                        Website interaction and usage information
                    </li>
                </ul>

            </div>


            <!-- 03 -->
            <div class="privacy-policy-item">

                <h3>
                    <span>03</span>
                    How We Use Your Information
                </h3>

                <p>
                    SolarCiti may use the information collected from you
                    for purposes related to providing and improving our
                    solar products and services.
                </p>

                <ul>
                    <li>
                        <i class="bx bx-check"></i>
                        Respond to your enquiries and requests
                    </li>

                    <li>
                        <i class="bx bx-check"></i>
                        Provide solar consultation and information
                    </li>

                    <li>
                        <i class="bx bx-check"></i>
                        Prepare and communicate solar proposals or quotations
                    </li>

                    <li>
                        <i class="bx bx-check"></i>
                        Help assess your solar energy requirements
                    </li>

                    <li>
                        <i class="bx bx-check"></i>
                        Provide installation and related services
                    </li>

                    <li>
                        <i class="bx bx-check"></i>
                        Provide customer support and service updates
                    </li>

                    <li>
                        <i class="bx bx-check"></i>
                        Improve our website, products, and services
                    </li>

                    <li>
                        <i class="bx bx-check"></i>
                        Maintain website security and prevent misuse
                    </li>
                </ul>

            </div>


            <!-- 04 -->
            <div class="privacy-policy-item">

                <h3>
                    <span>04</span>
                    Solar Calculator & Energy Information
                </h3>

                <p>
                    If you use the SolarCiti solar calculator or submit
                    information regarding your electricity consumption,
                    property, or energy requirements, we may use that
                    information to provide calculations, recommendations,
                    estimates, or other solar-related assistance.
                </p>

                <p>
                    Any calculation or estimate provided through the
                    website is intended for informational purposes and
                    may vary depending on actual site conditions, energy
                    consumption, equipment, installation conditions, and
                    other relevant factors.
                </p>

            </div>


            <!-- 05 -->
            <div class="privacy-policy-item">

                <h3>
                    <span>05</span>
                    Cookies and Similar Technologies
                </h3>

                <p>
                    SolarCiti may use cookies and similar technologies
                    to support website functionality, understand website
                    usage, improve user experience, and maintain website
                    performance.
                </p>

                <p>
                    You may be able to control or disable cookies through
                    your browser settings. Disabling certain cookies may
                    affect some website functionality.
                </p>

            </div>


            <!-- 06 -->
            <div class="privacy-policy-item">

                <h3>
                    <span>06</span>
                    Sharing of Information
                </h3>

                <p>
                    SolarCiti does not sell or rent your Personal Information
                    to third parties for their independent use.
                </p>

                <p>
                    Information may be shared where reasonably necessary
                    to provide requested services, operate our website,
                    respond to enquiries, comply with applicable laws, or
                    protect the rights and security of SolarCiti and its
                    users.
                </p>

                <p>
                    Where third-party service providers are used to support
                    our operations, they may receive only the information
                    reasonably necessary to perform the relevant service.
                </p>

            </div>


            <!-- 07 -->
            <div class="privacy-policy-item">

                <h3>
                    <span>07</span>
                    Data Security
                </h3>

                <p>
                    SolarCiti takes reasonable measures to protect the
                    information provided by users against unauthorized
                    access, misuse, alteration, disclosure, or loss.
                </p>

                <p>
                    However, no method of transmission over the internet
                    or electronic storage can be guaranteed to be completely
                    secure. Therefore, while we take reasonable precautions,
                    absolute security cannot be guaranteed.
                </p>

            </div>


            <!-- 08 -->
            <div class="privacy-policy-item">

                <h3>
                    <span>08</span>
                    Data Retention
                </h3>

                <p>
                    SolarCiti may retain your information for as long as
                    reasonably necessary to provide requested services,
                    maintain business records, resolve enquiries, comply
                    with applicable legal obligations, and protect our
                    legitimate business interests.
                </p>

            </div>


            <!-- 09 -->
            <div class="privacy-policy-item">

                <h3>
                    <span>09</span>
                    Your Choices
                </h3>

                <p>
                    You may contact SolarCiti if you have questions about
                    the personal information you have provided to us or
                    if you would like to request correction or clarification
                    of your information, subject to applicable laws and
                    legitimate business requirements.
                </p>

            </div>


            <!-- 10 -->
            <div class="privacy-policy-item">

                <h3>
                    <span>10</span>
                    Third-Party Websites
                </h3>

                <p>
                    Our website may contain links to third-party websites,
                    services, or platforms. SolarCiti is not responsible for
                    the privacy practices, content, or security practices
                    of third-party websites.
                </p>

                <p>
                    We recommend reviewing the privacy policies of any
                    third-party website before providing personal information.
                </p>

            </div>


            <!-- 11 -->
            <div class="privacy-policy-item">

                <h3>
                    <span>11</span>
                    Communication Consent
                </h3>

                <p>
                    When you submit an enquiry, request a quotation,
                    request a consultation, or otherwise provide your
                    contact details to SolarCiti, you may be contacted
                    regarding your enquiry, requested services, solar
                    solutions, or related support.
                </p>

                <p>
                    You may contact us if you no longer wish to receive
                    non-essential communications from us, subject to
                    applicable legal or service-related requirements.
                </p>

            </div>


            <!-- 12 -->
            <div class="privacy-policy-item">

                <h3>
                    <span>12</span>
                    Children's Privacy
                </h3>

                <p>
                    SolarCiti's website and services are intended for
                    general users and are not specifically directed toward
                    children. We do not knowingly request personal
                    information from children for purposes that are
                    prohibited by applicable law.
                </p>

            </div>


            <!-- 13 -->
            <div class="privacy-policy-item">

                <h3>
                    <span>13</span>
                    Changes to This Privacy Policy
                </h3>

                <p>
                    SolarCiti may update this Privacy Policy from time to
                    time to reflect changes in our services, website,
                    business practices, or applicable requirements.
                </p>

                <p>
                    Any updated version will be published on this page.
                    We encourage you to periodically review this Privacy
                    Policy for the latest information.
                </p>

            </div>


            <!-- 14 -->
            <div class="privacy-policy-item">

                <h3>
                    <span>14</span>
                    Governing Law
                </h3>

                <p>
                    This Privacy Policy and your use of the SolarCiti
                    website shall be governed by the applicable laws of
                    India, subject to the jurisdiction of the appropriate
                    courts in India.
                </p>

            </div>


            <!-- Contact -->
            <div class="privacy-contact-box">

                <div class="privacy-contact-icon">
                    <i class="bx bx-envelope"></i>
                </div>

                <div class="privacy-contact-content">

                    <span>
                        Questions or Grievances?
                    </span>

                    <h3>
                        We're here to help.
                    </h3>

                    <p>
                        If you have any questions, concerns, or grievances
                        regarding this Privacy Policy or the way SolarCiti
                        handles your information, please contact us.
                    </p>

                    <a href="mailto:YOUR_EMAIL@example.com">
                        YOUR_EMAIL@example.com
                    </a>

                </div>

            </div>

        </div>

    </div>
</section>
<!-- End Privacy Policy Area -->